import { Mutation } from 'react-apollo';
import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import GameQuery from '../../query/GameQuery';
import SubmitMutation from '../../mutations/Submit';
import SubmitComponent from '../../components/Submit';
import { RESULTS, BUSINESSPLAN } from '../../routes';
import { formatRoute } from 'react-router-named-routes';
import cloneDeep from 'lodash/cloneDeep';
import find from 'lodash/find';
import gql from 'graphql-tag';

const SAVE_GAME_MUTATION = gql`
	mutation($gameID: ID!, $data: JSON!) {
		updateGame(gameID: $gameID, data: $data) {
			id
			data
		}
	}
`;

const Submit = ({ history }) => {
	function saveGame(mutate, game, data) {
		const fragment = gql`
			fragment gameFragment on Game {
				id
				data
			}
		`;
		const newGame = data.client.cache.readFragment({
			fragment,
			id: `Game:${game.id}`
		});
		const gameData = cloneDeep(newGame.data);
		gameData.test = gameData.test + 1 || 0;
		mutate({
			variables: {
				gameID: game.id,
				data: gameData
			}
		});
	}
	return (
		<GameQuery>
			{query => (
				<SubmitMutation>
					{({ submit, startLoading, stopLoading }) => (
						<Mutation mutation={SAVE_GAME_MUTATION}>
							{(saveGameMutation, dataSave) => (
								<SubmitComponent
									onClick={() => {
										startLoading();
										submit({
											variables: {
												gameID: query.game.id
											}
										}).then(data => {
											saveGame(saveGameMutation, query.game, dataSave);
											stopLoading();
											const game = data.data.submit;
											if (game.data.state === 'COMPLETED') {
												history.push(
													formatRoute(RESULTS, {
														gameID: game.id
													})
												);
											} else {
												const businessPlan = find(game.data.businessPlans, {
													submission: game.data.lastSubmission
												});
												history.push(
													formatRoute(BUSINESSPLAN, {
														gameID: game.id,
														businessPlanID: businessPlan.submission
													})
												);
											}
										});
									}}
									count={
										query.game.businessPlan
											? query.game.businessPlan.submission
											: query.game.lastSubmission
									}
									label={'Submit'}
								/>
							)}
						</Mutation>
					)}
				</SubmitMutation>
			)}
		</GameQuery>
	);
};

Submit.propTypes = {
	count: PropTypes.number
};

export default Submit;
